import { TableCell } from '@mui/material';
import { useSnapshot } from 'features/snapshots/api/getSnapshot';

interface Props {
  snapshotId: number;
}

const SnapshotTableCells = ({ snapshotId }: Props) => {
  const { data: snapshot } = useSnapshot({ snapshotId });
  return (
    <>
      <TableCell>{snapshot?.name || ''}</TableCell>
      <TableCell>{snapshot?.last_reported_sweep_time} ms</TableCell>
    </>
  );
};

export default SnapshotTableCells;
